export const ESTADO_COBRADO = 'cobrado';
export const ESTADOS_FECHA_COBRO = [
  ESTADO_COBRADO,
  'pendiente',
  'devuelto',
  'incobrable',
  'cancelado',
];
